import type { JobTitle } from '@/models/taxonomy/job';
import type { Skill } from '@/models/taxonomy/skills';

const getUserOccupationSkillsOrderedByScore = (skills: Skill[]) => {
  const orderedSkills = [...skills];
  return orderedSkills.sort((a, b) => (b?.score ?? 0) - (a?.score ?? 0));
};

export const getAllOccupationSkills = (userJobs: {
  current?: JobTitle;
  desired?: JobTitle;
}) => {
  const allSkills = [
    ...(userJobs.current?.occupation?.skill_designations ?? []),
    ...(userJobs.desired?.occupation?.skill_designations ?? []),
  ];

  return getUserOccupationSkillsOrderedByScore(allSkills);
};
